import React from 'react';
import { UtpCardSection } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../entrance-doors-constants';
import { ENTRANCE_DOORS_HOUSE_CARD_LIST } from './entrance-doors-house-section-constants';
import {
  entranceDoorsHouseSectionCard,
  entranceDoorsHouseSectionTitle,
} from './entrance-doors-house-section-styles';

type EntranceDoorsUtpSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const EntranceDoorsHouseSection = ({
  onConsultationSignupBtnClick,
}: EntranceDoorsUtpSectionProps) => (
  <UtpCardSection
    elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
    elementText="Входные двери для частного дома"
    renderModalContent={({ modal: { content: ModalContent } = {} }, onCloseModal) => (
      ModalContent && <ModalContent
        onConsultationSignupBtnClick={() => {
          onCloseModal();
          onConsultationSignupBtnClick();
        }}
      />
    )}
    title="Входные двери для частного дома"
    utpCardList={ENTRANCE_DOORS_HOUSE_CARD_LIST}
    titleClassName={entranceDoorsHouseSectionTitle}
    cardClassName={entranceDoorsHouseSectionCard}
  />
);
